import axiosInstance from "./axiosInstance";

// ================= TYPES =================

export interface PaginationParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

// ================= DASHBOARD =================

export const getDashboardStats = () =>
  axiosInstance.get("/admin/dashboard");

// ================= AUTH =================

// 📲 Send OTP
export const sendOtp = (mobile: string) =>
  axiosInstance.post("/auth/send-otp", { mobile });

// ✅ Verify OTP
export const verifyOtp = (mobile: string, otp: string) =>
  axiosInstance.post("/auth/verify-otp", { mobile, otp });

// ================= USERS =================

// 👥 Get all users
export const getUsers = (params?: PaginationParams) =>
  axiosInstance.get("/admin/users", { params });

// 🚫 Block / Unblock user (toggle)
export const toggleUserBlock = (id: string) =>
  axiosInstance.patch(`/admin/users/${id}/block`);

// 🔥 OLD SUPPORT (for existing UI)
export const updateUserStatus = (id: string, _status?: string) =>
  toggleUserBlock(id);

// ================= PROVIDERS =================

// 🧑‍🔧 Get all providers (with filter)
export const getProviders = (params?: { status?: string }) =>
  axiosInstance.get("/admin/providers", { params });

// ✅ Approve / Reject provider
export const updateProviderStatus = (id: string, status: string) =>
  axiosInstance.patch(`/admin/providers/${id}/status`, { status });

// ================= SUPPORT (TICKETS) =================

// 🎫 Get all tickets
export const getTickets = () =>
  axiosInstance.get("/admin/tickets");

// 🔄 Update ticket status
export const updateTicketStatus = (id: string, status: string) =>
  axiosInstance.patch(`/admin/tickets/${id}/status`, { status });

// 🔥 OLD SUPPORT (for existing UI)
export const getSupportTickets = () => getTickets();

// ================= PAYMENTS =================
export const getPayments = (params?: PaginationParams & {
  role?: string;
}) =>
  axiosInstance.get("/admin/payments", { params });

// ================= NOTIFICATIONS =================

// 🔔 Get notifications (same API for admin & user)
export const getNotifications = () =>
  axiosInstance.get("/notifications");

// 🔢 Unread count
export const getUnreadCount = () =>
  axiosInstance.get("/notifications/unread-count");

// 📩 Mark as read
export const markAsRead = (id: string) =>
  axiosInstance.put(`/notifications/read/${id}`);